import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ priceFormatted: _ctx.priceFormatted, currencyConfig: _ctx.currencyConfig })), () => [
    _createTextVNode(_toDisplayString(_ctx.priceFormatted), 1)
  ])
}